import {Link} from 'react-router-dom';
import {useLocale} from '@/context/LocaleContext';
import {PORTALS,portalHref} from '@/lib/portalAccess';
export default function PortalEntries({user=false}) {
  const {t}=useLocale();
  return <nav aria-label={t('Giriş portalları')} data-testid="portal-entries" className="grid grid-cols-3 gap-2 w-full sm:w-auto">
    {PORTALS.map(portal=><Link key={portal.id} data-testid={'portal-entry-'+portal.id} to={portalHref(portal,user)} className="min-h-[44px] rounded-xl border border-shule-lineaccent bg-shule-paper hover:bg-shule-cream focus-visible:outline focus-visible:outline-2 focus-visible:outline-shule-coffee px-2 sm:px-4 py-2 text-center text-xs sm:text-sm font-semibold inline-flex items-center justify-center">{t(portal.label)}</Link>)}
  </nav>;
}
